export default function formatHouseholdCount(total) {
  if (typeof (total) === 'number') {
    return total.toString();
  }

  return undefined;
}
